module.exports = __webpack_public_path__ + "img/UZ.19783622.png";